import { ArrangementGroup, ArrangementObject, Entity } from "@rhinov/savane-js";
import { EntityController } from "../EntityController";

 export class EntityWidget {

    entity: Entity;
    controller: EntityController;
    panel: any;
    openAssetDetailCallback: CallableFunction | null;
    deliverable: any;
    propertiesTab: string[] = [];

    swapChild = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { prop?: any, param?: string, specifier?: number }
        var property = elem.prop;
        var child = elem.param;
        var callback = () => {
            this.removechildListListener();
            let element = document.getElementById('childList');
            if (element) {
                element.innerHTML = this.buildChildList(property);
                this.setchildListListener(property);
            }
        };
        if (elem.specifier === -1) {
            this.controller.moveChildDown(child, callback);
        } else {
            this.controller.moveChildUp(child, callback);
        }
    }

    removechild = (event: Event) => {
        this.controller.extractItem((event.currentTarget as HTMLInputElement & { param?: any }).param.entity);
    }

    setBoolean = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { param?: any };
        var value = Number(elem.value);
        var child = elem.param;
        child.entity.boolean = value;
    }

    setToggle = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { prop?: any, param?: number };
        let property = elem.prop;
        this.controller.setToggleValue(property.key, elem.param !== undefined ? elem.param : elem.checked);
    }

    setRangeValue = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { prop?: any };
        let property = elem.prop;
        this.controller.setPropertiesValues(property.key, elem.value, 1);
        this.refreshPanel();
    }

    refreshPanel = () => {
        this.controller.updateProperties(undefined);
    }

    plusLessHandle = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { prop?: any, specifier?: string, param?: string };
        if (elem.param === "+"){
            this.controller.addPropertiesValues(elem.prop.key + elem.specifier, elem.prop.buttonStep)
        } else {
            this.controller.addPropertiesValues(elem.prop.key + elem.specifier, -elem.prop.buttonStep)
        }
        this.refreshPanel();
    }

    changeDropdown = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { prop?: any };
        var key = elem.prop.key;
        this.controller.model[key] = elem.value;
        this.controller.setPropertiesValues(key, this.controller.model[key], 1.0);
        this.controller.updateProperties(undefined);
    }

    setEntityValue = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { prop?: any, specifier?: string }
        this.controller.setPropertiesValues(elem.prop.key + elem.specifier,  elem.value, elem.prop.buttonStep);
    }

    previewDetails = (event: MouseEvent) => {
        if (event.ctrlKey) {
            this.controller.openEntityDetail();
        }
    }

    handleBlameLayout = () => {
        this.controller.blameLayout();
    }

    constructor (entity: Entity, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction | null = null) {
        this.entity = entity;
        this.panel = panel;
        this.openAssetDetailCallback = openAssetDetailCallback;
        this.deliverable = deliverable;
        this.controller = new EntityController(entity, panel, deliverable, openAssetDetailCallback);
    }

    nameHeader (): string {
        return `
            <!-- NAME ? -->
            <div id="propPanelName" style="padding-left:10px">
                <div style="padding-right: 50px">${this.panel.name}</div>
            </div>
            `;
    }
    propertyStart(): string {
        return `
            <div id="propertiesList" class="${this.panel.key} properties-list" style="width:fit-content; max-height:750px">
        `;
    }

    propertyEnd(): string {
        return `
            </div>
        `;
    }

    staticCm(property: any): string {
        return `
            <!-- CM values (static) -->
            <div class="property-item padding ${property.key}">
                <div class="form${property.key}">
                    <div style="padding-top:15px">
                        <div class="input-wrapper col-xs-12">
                            <input disabled id="static${property.key}" type="number" step=${property.step}
                                class="${property.orientation=== 'vertical' ? 'col-xs-5' : 'form-control'}">
                            <span>${property.unit ? property.unit : ""}</span>
                        </div>
                        <h class="${property.orientation === 'vertical' ? 'col-xs-7 ' : ''}">
                            cm ${property.text}
                        </h>
                        <div class="clearfix"></div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        `;
    }

    isPlusLessTitle(property: any): string {
        if (property.title) {
            return `
                <!-- input name -->
                <h style="padding-bottom:20px;font-weight:600;">
                    ${property.title}
                </h>
            `;
        }
        return "";
    }

    isPlusLessCm(property: any): string {
        if (property.kind === 'plus-less-cm') {
            return `
                <div class="cm-display">
                    <h> cm </h>
                </div>
            `;
        }
        return "";
    }

    plusLess(property: any): string {
        return `
            <!-- Input  & +/- button -->
            <div
                class="property-item padding ${property.key}" style="display : ${this.controller.showPropertiesValues(property.key) ? 'flex' : 'none'}">
                <div class="add-remove form${property.key}">
                    <div class="add-remove-input">
                        ${this.isPlusLessTitle(property)}
                        <!-- input field -->
                        <div class="input-wrapper">
                            <input id="box-${property.key}" onClick="this.select();"
                                class="inputEnterValited input${property.key} form-control" type="number"
                                step=${property.step}>
                            <span>${property.unit ? property.unit : ""}</span>
                        </div>
                        <!-- Unit -->
                        <h>
                            ${property.text === undefined ? "" : property.text}
                        </h>
                    </div>
                    ${this.isPlusLessCm(property)}
                    <div class="add-remove-buttons" style="display :${this.controller.enabledPropertiesValues(property.key) ? 'flex' : 'none'}">
                        <div id="less-${property.key}" style="float:left;" class="btn btn-flat btn-default min less"
                            data-type=${property.key}>
                            <i style="font-size:14px;">-</i>
                        </div>
                        <div id="plus-${property.key}" style="float:right;" class="btn btn-flat btn-default max more"
                            data-type=${property.key}>
                            <i style="font-size:10px;font-weight:900;"
                                class="material-icons icon-FloatBar_Plus"></i>
                        </div>
                    </div>
                </div>
            </div>   
        `;
    }

    setplusLessListener(property: any, specifier: string) {
        let box = document.getElementById(`box${specifier ? specifier : ""}-${property.key}`) as HTMLInputElement & { prop?: any, specifier?: string };
        if (box) {
            box.prop = property;
            box.specifier = specifier ? specifier : "";
            box.addEventListener('blur', this.refreshPanel);
            box.addEventListener('input', this.setEntityValue);
        }
        let plus = document.getElementById(`plus${specifier ? specifier : ""}-${property.key}`) as HTMLInputElement & { prop?: any, specifier?: string, param?: string };
        if (plus) {
            plus.prop = property;
            plus.param = "+";
            plus.specifier = specifier ? specifier : "";
            plus.addEventListener('click', this.plusLessHandle)
        }

        let less = document.getElementById(`less${specifier ? specifier : ""}-${property.key}`) as HTMLInputElement & { prop?: any, specifier?: string, param?: string };
        if (less) {
            less.prop = property;
            less.param = "-";
            less.specifier = specifier ? specifier : "";
            less.addEventListener('click', this.plusLessHandle);
        }
    }

    removeplusLessListener(property: any, specifier: string) {
        let box = document.getElementById(`box${specifier ? specifier : ""}-${property.key}`);
        if (box) {
            box.removeEventListener('blur', this.refreshPanel)
            box.removeEventListener('input', this.setEntityValue);
        }
        let plus = document.getElementById(`plus${specifier ? specifier : ""}-${property.key}`);
        if (plus) {
            plus.removeEventListener('click', this.plusLessHandle)
        }

        let less = document.getElementById(`less${specifier ? specifier : ""}-${property.key}`);
        if (less) {
            less.removeEventListener('click', this.plusLessHandle);
        }
    }
    
    range(property: any): string {
        if ((property.key !== 'leftOpeningAngle' || property.key === 'leftOpeningAngle' && ((this.entity as any).nbDoors === 2 || (this.entity as any).nbCasement === 2)) && this.controller.showPropertiesValues(property.key)) {
        return `
            <!--Range input -->
            <div id="rangeContainer-${property.key}" style="min-width : 200px" class="property-item padding">
                <div>
                    <h5 id="valueRange-${property.key}" class="labelRange">${property.title} :
                        ${this.controller.dynamicRangeCall(property.funcLabel, (this.entity as any)[property.key])} </h5>
                </div>
                <div style="display:inline-flex">
                    <p>${property.minLabel || property.min}</p>
                    <div>
                        <input id="range-${property.key}" class="inputRange${property.key}" min="${this.controller.getRangeMin(property)}" max="${this.controller.getRangeMax(property)}"
                            type="range" step="${property.step ? property.step : 1}"/>
                    </div>
                    <p>${property.maxLabel || property.max}</p>
                </div>
            </div>  
        `;
        }
        return "";
    }

    setrangeListener(property: any) {
        let range = document.getElementById(`range-${property.key}`) as HTMLInputElement & { prop?: any };
        if (range) {
            range.value = (this.entity as any)[property.key];
            range.prop = property;
            range.addEventListener('input', this.setRangeValue);
        }
    }

    removerangeListener(property: any) {
        let range = document.getElementById(`range-${property.key}`);
        if (range) {
            range.removeEventListener('input', this.setRangeValue);
        }
    }

    numValueToggle(property: any): string {
        return `
            <!-- plinths toggle FIXME Why not using generic toggle -->
            <div class="property-item padding">
                <div class="togglebutton ${property.key}">
                    <label class="horizontal-toggle">
                        <div style="padding-right: 10px">${property.title}</div>
                        <input id="buttonToggle-${property.key}" type="checkbox">
                        <span class="toggle "></span>
                    </label>
                </div>
                <div id="plinthHeight-${property.key}" class="nopadding ${property.key}Height">
                    <div style="padding-top:15px"
                        class=" label-floating add-remove form${property.key}Height ">
                        <div style="width:90px;padding:0px">
                            <div class="input-wrapper">
                                <input id="boxHeight-${property.key}" onClick="this.select();"
                                    class="inputEnterValited input${property.key}Height form-control" type="number"
                                    step=${property.step}>
                            </div>
                            <h>
                                ${property.text}
                            </h>
                            <div class="clearfix"></div>
                        </div>
                        <div class="cm-display" style="float:left">
                            <h> cm </h>
                        </div>
                        <div class="add-remove-buttons  ">
                            <div id="lessHeight-${property.key}" class="btn btn-flat btn-default  min less" data-type=${property.key}Height>
                            <i style="font-size:14px;">-</i>
                            </div>
                            <div id="plusHeight-${property.key}" class="btn btn-flat btn-default  max more" data-type=${property.key}Height>
                            <i style="font-size:10px;font-weight:900;"
                                    class="material-icons icon-FloatBar_Plus"></i>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        `;
    }

    setnumValueToggleListener(property: any) {
        this.setplusLessListener(property, "Height");
        this.setbuttonToggleListener(property)
    }

    removenumValueToggleListener(property: any) {
        this.removeplusLessListener(property, "Height");
        this.removebuttonToggleListener(property)
    }

    handlearrow(child: any, index: number): string {
        var html = "";
        if (child !== this.controller.entityChildrenBis[0]){
            html += `<div id="moveup-${index}" style="cursor: pointer;" class="col-xs-2"><i class="fa-solid fa-arrow-up"></i></div>`
        }
        if (child !== this.controller.entityChildrenBis[this.controller.entityChildrenBis.length - 1]) {
            html += `<div id="movedown-${index}" style="cursor: pointer;" class="col-xs-2"><i class="fa-solid fa-arrow-down"></i></div>`;
        }
        return html;
    }

    childOperationsOptions(): string {
        var html = "";
        this.controller.dropDownDatas['boolean'].forEach((option: any) => {
            html += `
                <option class="drop_down_option"
                    value="${option.value}">${option.name}
                </option>
            `
        })
        return html;
    }

    buildChildList(property: any): string {
        var html = "";
        var index = 0;
        this.controller.entityChildrenBis.forEach((child: any) => {
            html += `
                <li style="margin-bottom:2px;">
                    ${child.preview ? `<img style="width:45px;height:45px;" src="${child.preview}" />` : ""}
                    <span>${child.name}</span>
                    <button id="removeChild-${index}" type="button" class="btn btn-flat btn-default" style="display: ${child.entity.canLeaveGroup ? (child.entity.canLeaveGroup() ? "flex" : "none") : "none"}">
                        <i class="material-icons icon-ungroup"></i>
                    </button>
                    <div style="display : ${child.boolean ? "block" : "none"} ">
                        <span>Opération Booléenne : </span>
                        <div class="row">
                            <div class="col-xs-8">
                                <select id="booleanOperation-${index}" class="form-control dropDown${property.key}">
                                    ${this.childOperationsOptions()}
                                </select>
                            </div>
                            ${this.handlearrow(child, index)}
                        </div>
                    </div>
                </li>
            `;
            index++;
        })
        return html;
    }

    childList(property: any): string {
        return `
            <!-- List of child elements (mainly for arrangements) -->
            <div class="property-item padding">
                <div class=" nopadding" translate>Liste des objets du groupe</div>
                <ul id="childList" class="col-xs-12" style="max-height: 650px;overflow: auto;">
                    ${this.buildChildList(property)}
                </ul>
            </div>
        `;
    }

    setchildListListener(property: any) {
        var index = 0;
        this.controller.entityChildrenBis.forEach((child: any) => {
            let button = document.getElementById(`removeChild-${index}`) as HTMLInputElement & {param?: any};
            if (button) {
                button.param = child;
                button.addEventListener('click', this.removechild);
            }
            let boolean = document.getElementById(`booleanOperation-${index}`) as HTMLInputElement & {param?: any};
            if (boolean) {
                boolean.param = child;
                boolean.value = child.entity.boolean;
                boolean.addEventListener('change', this.setBoolean);
            }
            let arrowdown = document.getElementById(`movedown-${index}`) as HTMLElement & {prop?: any, param?: any, specifier?: number};
            if (arrowdown) {
                arrowdown.prop = property;
                arrowdown.param = child;
                arrowdown.specifier = -1;
                arrowdown.addEventListener('click', this.swapChild)
            }
            let arrowup = document.getElementById(`moveup-${index}`) as HTMLElement & {prop?: any, param?: any, specifier?: number};
            if (arrowup) {
                arrowup.prop = property;
                arrowup.param = child;
                arrowup.specifier = 1;
                arrowup.addEventListener('click', this.swapChild)
            }
            index++;
        })
    }

    removechildListListener() {
        var index = 0;
        this.controller.entityChildrenBis.forEach((child: any) => {
            let button = document.getElementById(`removeChild-${index}`);
            if (button) {
                button.removeEventListener('click', this.removechild);
            }
            let boolean = document.getElementById(`booleanOperation-${index}`);
            if (boolean) {
                boolean.removeEventListener('change', this.setBoolean);
            }
            let arrowdown = document.getElementById(`movedown-${index}`);
            if (arrowdown) {
                arrowdown.removeEventListener('click', this.swapChild)
            }
            let arrowup = document.getElementById(`moveup-${index}`);
            if (arrowup) {
                arrowup.removeEventListener('click', this.swapChild)
            }
            index++;
        })
    }

    buttonToggle(property: any): string {
        return `
            <!-- Toggle -->
            <div class="property-item padding ${property.key} ">
                <div class="form${property.key} togglebutton">
                    <label class="horizontal-toggle">
                        <div style="padding-right: 10px;float:left">${property.text}</div>
                        <input id="buttonToggle-${property.key}" type="checkbox"
                            class="togglebutton${property.key}">
                        <span style="float:right" class="toggle"></span>
                    </label>
                </div>
            </div>
        `;
    }

    setbuttonToggleListener(property: any) {
        let toggle = document.getElementById(`buttonToggle-${property.key}`) as HTMLInputElement & { prop?: any };
        if (toggle) {
            toggle.prop = property;
            toggle.addEventListener('change', this.setToggle);
        }
    }

    removebuttonToggleListener(property: any) {
        let toggle = document.getElementById(`buttonToggle-${property.key}`) as HTMLInputElement & { prop?: any };
        if (toggle) {
            toggle.prop = property;
            toggle.removeEventListener('change', this.setToggle);
        }
    }

    buttonToggleLight(property: any): string {
        if ((this.entity as any)[property.key] !== undefined) {
            return `
                <!-- Toggle light -->
                <div class="property-item padding ${property.key} ">
                    <div class="form${property.key} togglebutton">
                        <label class="horizontal-toggle">
                            <div style="padding-right: 10px;float:left">${property.text}</div>
                            <input id="buttonToggle-${property.key}" type="checkbox"
                                class="togglebutton${property.key}}">
                            <span style="float:right" class="toggle"></span>
                        </label>
                    </div>
                </div>
            `;
        }
        return "";
    }

    setbuttonToggleLightListener(property: any) {
        this.setbuttonToggleListener(property)
    }

    removebuttonToggleLightListener(property: any) {
        this.removebuttonToggleListener(property);
    }

    buttonToggleShutter(property: any): string {
        return `
            <!-- Toggle shutter -->
            <div class="property-item padding ${property.key} ">
                <div class="form${property.key} togglebutton">
                    <label class="horizontal-toggle">
                        <div style="padding-right: 10px;float:left">${property.text}</div>
                        <input id="buttonToggle-${property.key}" type="checkbox">
                        <span style="float:right" class="toggle"></span>
                    </label>
                </div>
            </div>
        `;
    }

    setbuttonToggleShutterListener(property: any) {
        this.setbuttonToggleListener(property)
    }

    removebuttonToggleShutterListener(property: any) {
        this.removebuttonToggleListener(property);
    }

    tripleToggle(property: any): string {
        return `
            <!-- Triple state toggle -->
            <div id="triple-${property.key}" class="property-item ${property.key} padding">
                <div class="form${property.key} triple-toggle">
                    <div class="triple-toggle-radios">
                        <input type="radio" name="event${property.key}" class="left"
                            id="radio-right1${property.key}" />
                        <label for="radio-right1${property.key}"></label>
                        <input type="radio" name="event${property.key}" class="middle" checked
                            id="radio-middle1${property.key}" />
                        <label for="radio-middle1${property.key}"></label>
                        <input type="radio" name="event${property.key}" class="right"
                            id="radio-left1${property.key}" />
                        <label for="radio-left1${property.key}"></label>
                    </div>
                    <label>${property.text}</label>
                </div>
            </div>
        `;
    }

    settripleToggleListener(property: any) {
        let left = document.getElementById(`radio-right1${property.key}`) as HTMLInputElement & { prop?: any, param?: number };
        if (left) {
            left.prop = property;
            left.param = -1;
            left.addEventListener('click', this.setToggle);
        }
        let middle = document.getElementById(`radio-middle1${property.key}`) as HTMLInputElement & { prop?: any, param?: number };
        if (middle) {
            middle.prop = property;
            middle.param = 0;
            middle.addEventListener('click', this.setToggle);
        }
        let right = document.getElementById(`radio-left1${property.key}`) as HTMLInputElement & { prop?: any, param?: number };
        if (right) {
            right.prop = property;
            right.param = 1;
            right.addEventListener('click', this.setToggle);
        }
    }

    removetripleToggleListener(property: any) {
        let left = document.getElementById(`radio-right1${property.key}`);
        if (left) {
            left.removeEventListener('click', this.setToggle);
        }
        let middle = document.getElementById(`radio-middle1${property.key}`);
        if (middle) {
            middle.removeEventListener('click', this.setToggle);
        }
        let right = document.getElementById(`radio-left1${property.key}`);
        if (right) {
            right.removeEventListener('click', this.setToggle);
        }
    }


    handleDropDownOptions(property: any): string {
        var html = "";
        this.controller.dropDownDatas[this.controller.getDataName(property.data_name)].forEach((option: any) => {
            html += `
                <option class="drop_down_option"
                    value="${option.value}">${option.name}
                </option>
            `;
        })
        return html;
    }

    dropDown(property: any): string {
        if ((this.entity as any)[property.key] !== undefined) {
            return `
                <!-- Dropdown -->
                <div id="${property.key}" class="property-item ${property.key} padding">
                    <div class="drop_down">
                        <label class="control-label " for="property1">${property.text}</label>
                        <select id="property${property.key}" class="form-control dropDown${property.key}"
                            placeholder="Selectionner">
                            ${this.handleDropDownOptions(property)}
                        </select>
                    </div>
                </div>
            `;
        }
        return "";
    }

    setdropDownListener(property: any) {
        let element = document.getElementById(`property${property.key}`) as HTMLInputElement & { prop?: any };
        if (element) {
            element.value = this.controller.model[property.key];
            element.prop = property;
            element.addEventListener('change', this.changeDropdown);
        }
    }

    removedropDownListener(property: any) {
        let element = document.getElementById(`property${property.key}`);
        if (element) {
            element.removeEventListener('change', this.changeDropdown);
        }
    }

    colorSelector(property: any): string {
        return `
            <div id="colorSelector" class="property-item ${property.key} padding ${this.controller.model['temperature'] === '3' ? "" : 'hide'}">
                <div class="form-group nopadding">
                    ${
                        (this.entity as ArrangementObject).objectTypeConfig && (this.entity as ArrangementObject).objectTypeConfig.whiteOnly ? 
                        `<div style="color:red;">
                            Attention, cette lampe ne propose que la couleur blanche.
                        </div>` : ""
                    }
                    
                    <label class="control-label " for="colorPicker">${property.text}</label>
                    <input id="colorPicker" class="color-picker-tulip">
                </div>
            </div>
        `;
    }
    
    blameLayout(property: any): string {
        if ((this.entity as ArrangementGroup).AMLayoutId) {
            return `
                <div class="property-item padding ${property.key}">
                    <div class="form-group nopadding">
                        <button id="blameLayout" type="button" class="btn btn-flat btn-primary borderless"
                            style="background:#286090" translate>
                            Signaler le peuplement
                        </button>
                    </div>
                </div>
            `;
        }
        return "";
    }

    setblameLayoutListener() {
        let blame = document.getElementById('blameLayout');
        if (blame) {
            blame.addEventListener('click', this.handleBlameLayout)
        }
    }

    removeblameLayoutListener() {
        let blame = document.getElementById('blameLayout');
        if (blame) {
            blame.removeEventListener('click', this.handleBlameLayout)
        }
    }

    setListener() {
        var i;
        for (i = 0; i < this.propertiesTab.length; i++) {
            if ((this as any)['set' + this.propertiesTab[i] + 'Listener'] !== undefined) {
                (this as any)['set' + this.propertiesTab[i] + 'Listener'](this.panel.properties[i]);
            }
        }
        return;
    }

    removeListener() {
        var i;
        for (i = 0; i < this.propertiesTab.length; i++) {
            if ((this as any)['remove' + this.propertiesTab[i] + 'Listener'] !== undefined) {
                (this as any)['remove' + this.propertiesTab[i] + 'Listener'](this.panel.properties[i]);
            }
        }
        return;
    }
    
}